import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { CsiMilestone2PercentageBasedActivity } from '../../../../models/csi-milestone2-percentage-based-activity.model';
import { AppConstants } from '../../../common/app-constants';
import { CommonSharedModule } from '../../../common/shared.module';
import { CSIPaymentScheduleService } from '../../../services/csi-payment-schedule.service';
import { ExportService } from '../../../services/export.service';

@Component({
  selector: 'app-csi-engagement-milestone2',
  templateUrl: './csi-engagement-milestone2.component.html',
  styleUrls: ['./csi-engagement-milestone2.component.scss'],
  standalone: true,
  imports: [CommonSharedModule]
})
export class CsiEngagementMilestone2Component implements OnInit {
  @ViewChild('dt', { static: false }) dt!: Table;

  pscols!: any[];

  paymentBatchList: CsiMilestone2PercentageBasedActivity[] = [];
  loadingIcon = 'fa-circle-o-notch';
  dataViewRecsPerPage!: number;
  pageLinksPerPage!: number;
  tblPageNumber!: number;
  dateFormat = 'MM/dd/yyyy';

  totalRecords!: number;
  loading = false;
  isSpin = false;

  constructor(
    private csiService: CSIPaymentScheduleService,
    private exportService: ExportService
  ) {}

  ngOnInit(): void {
    this.loading = true;
    this.dataViewRecsPerPage = AppConstants.dataListRecsPerPage;
    this.pageLinksPerPage = AppConstants.dataListPagerLinks;
    this.pscols = [
      { field: 'partnerID', header: 'Partner ID', isDateFormat: false },
      { field: 'engagementID', header: 'Engagement ID', isDateFormat: false },
      {
        field: 'paymentLineItemId',
        header: 'Line Item ID',
        isDateFormat: false
      },
      { field: 'partnerName', header: 'Partner Name', isDateFormat: false },
      { field: 'vendorID', header: 'Vendor ID', isDateFormat: false },
      { field: 'tenantID', header: 'Tenant ID', isDateFormat: false },
      { field: 'tenantName', header: 'Tenant Name', isDateFormat: false },
      { field: 'customerID', header: 'Customer ID', isDateFormat: false },
      { field: 'customerName', header: 'Customer Name', isDateFormat: false },
      { field: 'engagementName', header: 'Workshop Name', isDateFormat: false },
      { field: 'status', header: 'Workshop Status', isDateFormat: false },
      {
        field: 'workshopDetailStatus',
        header: 'Workshop Detailed Status',
        isDateFormat: false
      },
      {
        field: 'completionDate',
        header: 'Completion Date',
        isDateFormat: true
      },
      { field: 'poeStatus', header: 'POE Status', isDateFormat: false },
      {
        field: 'poecompletionDate',
        header: 'POE Completion Date',
        isDateFormat: false
      },
      {
        field: 'l1InternalStatusName',
        header: 'L1InternalStatusName',
        isDateFormat: false
      },
      {
        field: 'm2PaymentBatchStatus',
        header: 'M2 Payment Batch Status',
        isDateFormat: false
      },
      { field: 'm2PaidDate', header: 'M2 Paid Date', isDateFormat: true },
      {
        field: 'mS2PaymentDesignation',
        header: 'MS2 Payment Designation',
        isDateFormat: false
      },
      {
        field: 'm2PaymentAmount',
        header: 'Milestone Two Payment Amount',
        isDateFormat: false
      },
      { field: 'area', header: 'Area', isDateFormat: false },
      { field: 'subsidiary', header: 'Subsidiary', isDateFormat: false },
      { field: 'm2PaidDate', header: 'MS Invoice Date', isDateFormat: true },
      {
        field: 'msInvoiceNo',
        header: 'MS Invoice Number',
        isDateFormat: false
      },
      {
        field: 'paymentCentralTransactionID',
        header: 'Payment Central Transaction ID',
        isDateFormat: false
      },
      { field: 'requestDate', header: 'Request Date', isDateFormat: true },
      { field: 'fiscalYear', header: 'Fiscal year', isDateFormat: false },
      {
        field: 'cumulativeAmount',
        header: 'Total Payment Amount',
        isDateFormat: false
      },
      { field: 'earnedDate', header: 'Earned Date', isDateFormat: true }
    ];
    this.getCsiMilestone2PaymentBatch();
  }

  getCsiMilestone2PaymentBatch() {
    this.csiService.getMilestone2PaymentActivitiesExport().subscribe(
      pbList => this.handlePaymentBatchResponse(pbList),
      error => this.handleError(error)
    );
  }

  handleError(error: any) {
    console.error('Error fetching payment batch:', error);
    this.loading = false;
  }
  handlePaymentBatchResponse(pbList: any) {
    if (pbList === null || pbList.length === null || pbList.length === 0) {
      this.loading = false;
    } else {
      this.paymentBatchList = pbList;
      this.totalRecords = this.paymentBatchList.length;

      this.loading = false;
    }
  }
  downloadM2PaymentEngagements() {
    this.isSpin = true;
    const dp = new DatePipe('en-US');
    const docname = 'CSI Engagements Milestone 2';
    if (this.paymentBatchList.length > 0) {
      const formattedData = this.paymentBatchList.map(item => {
        return this.pscols.reduce((formattedItem, column) => {
          formattedItem[column.header] = column.isDateFormat
            ? dp.transform(item[column.field], this.dateFormat)
            : item[column.field];
          return formattedItem;
        }, {});
      });
      this.exportService.exportToCsv(formattedData, docname);
      this.isSpin = false;
    }
  }
}
